import React from "react";
import { messageService, userData } from "./subscriberService";
import {
  access,
  activityType,
  activityType1,
  mediaStream,
  staticVar,
  timeDuration,
  getWhiteLabelData,
} from "./Constants";

import moment from "moment";
import { text } from "./TextFile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { colorSelector } from "../components/UI/selector";
import {
  ACTIVITY_STATUS,
  USER_STATUS_IN_ACTIVITY,
} from "../Constants/ActivityStatus";
import { BTN_TEXTS } from "../Constants/Texts";
import { differenceInSeconds, parseISO } from "date-fns";

// eslint-disable-next-line
const AntMediaUrl = {
  local: "wss://antmedia.tribe.fitness/WebRTCAppEE/websocket",
  develop: "wss://antmedia.tribe.fitness/WebRTCAppEE/websocket",
  staging: "wss://antmedia.tribe.fitness/staging/websocket",
  production: "wss://antmedia.tribe.fitness/prod/websocket",
  // develop: 'ws://antmedia.tribe.fitness:5080/WebRTCAppEE/websocket',
  // staging: 'ws://antmedia.tribe.fitness:5080/staging/websocket',
  // production: 'ws://antmedia.tribe.fitness:5080/prod/websocket'
};
// eslint-disable-next-line
const Urls = {
  local: "https://tribe.fitness.ngrok.io/",
  develop: "https://dev.api.tribe.fitness/",
  staging: "https://staging.api.tribe.fitness/",
  production: "https://api.tribe.fitness/",
  // production: 'https://api.tribe.fitness/'
};
// eslint-disable-next-line
const OnDemandSocket = {
  // develop: 'http://dev-service-318849498.us-east-1.elb.amazonaws.com?access_token=',
  // staging: 'http://staging-service-550164730.us-east-1.elb.amazonaws.com?access_token=',
  // production: 'http://prod-service-1399505486.us-east-1.elb.amazonaws.com?access_token='
  local: "https://tribe.fitness.ngrok.io?access_token=",
  develop: "https://dev.api.tribe.fitness?access_token=",
  staging: "https://staging.api.tribe.fitness?access_token=",
  production: "https://api.tribe.fitness?access_token=",
};
// eslint-disable-next-line
const appID = {
  local: {
    theBeat: "TRIBWB1648388803072",
    orangeTheory: "TRIBWB1657528203391",
    upState: "TRIBWB1627993315526",
    upBeat: "TRIBWB1659010349752",
    YFN: "TRIBWB1635760510031",
    woodsFit: "TRIBWB1637146774910",
    swyftSweat: "TRIBWB1637146535779",
    sweatShop: "TRIBWB1638169823413",
    kerrySports: "TRIBWB1640673172623",
    theUnion: "TRIBWB1646027997112",
    plyGrd: "TRIBWB1658908404535",
    barrys: "TRIBWB1663005875954",
    f45digital: "TRIBWB1665993084817",
    soulcycleDigital: "TRIBWB1666772626016",
  },
  develop: {
    theBeat: "TRIBWB1648388803072",
    orangeTheory: "TRIBWB1657528203391",
    upState: "TRIBWB1627993315526",
    upBeat: "TRIBWB1659010349752",
    YFN: "TRIBWB1635760510031",
    woodsFit: "TRIBWB1637146774910",
    swyftSweat: "TRIBWB1637146535779",
    sweatShop: "TRIBWB1638169823413",
    kerrySports: "TRIBWB1640673172623",
    theUnion: "TRIBWB1646027997112",
    plyGrd: "TRIBWB1658908404535",
    barrys: "TRIBWB1663005875954",
    f45digital: "TRIBWB1665993084817",
    soulcycleDigital: "TRIBWB1666772626016",
  },
  staging: {
    theBeat: "TRIBWB1648619862223",
    orangeTheory: "TRIBWB1657728584279",
    YFN: "TRIBWB1635760699335",
    woodsFit: "TRIBWB1638159721525",
    swyftSweat: "TRIBWB1637147088865",
    sweatShop: "TRIBWB1638170077139",
    kerrySports: "TRIBWB1648486423892",
    theUnion: "TRIBWB1655135130098",
    plyGrd: "TRIBWB1662143905647",
    f45digital: "TRIBWB1667375236505",
    soulcycleDigital: "TRIBWB1668442537989",
  },
  production: {
    theBeat: "TRIBWB1648619862223",
    orangeTheory: "TRIBWB1657728584279",
    YFN: "TRIBWB1635760699335",
    woodsFit: "TRIBWB1638159721525",
    swyftSweat: "TRIBWB1637147088865",
    sweatShop: "TRIBWB1638170077139",
    kerrySports: "TRIBWB1648486423892",
    theUnion: "TRIBWB1655135130098",
    plyGrd: "TRIBWB1662143905647",
    f45digital: "TRIBWB1667375236505",
    soulcycleDigital: "TRIBWB1668442537989",
  },
};

export const env = (status, types) => {
  // const type = 'local';
  const type = "develop";
  // const type = "staging";
  // const type = 'production';
  // eslint-disable-next-line
  return eval(status)[types || type];
};

export const randomString = (length) => {
  var result = [];
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result.push(
      characters.charAt(Math.floor(Math.random() * charactersLength))
    );
  }
  return result.join("");
};

// New Code Implementation for New Casting Class
export const message = {
  list: {},
  count: 0,
};

export const attendeeId = {};

// Show Message count
export const checkCount = (ref) => {
  return (ref.current && ref.current.count()) || 0;
};

export const convertTime = (totalSeconds, type = ":") => {
  const second = totalSeconds % 60;
  const minute = parseInt(totalSeconds / 60, 10);
  const minutes = parseInt(minute % 60, 10);
  const hour = parseInt(minute / 60, 10);

  let time = "";
  if (hour > 0) {
    time += checkLength(hour) + type;
  }
  if (minutes > 0) {
    time += checkLength(minutes) + type;
  }
  time += checkLength(second);
  return time;
};
export const convertTime1 = (totalSeconds, type = ":", status = "ms") => {
  const { hour, minutes, second } = getTime(totalSeconds);
  // console.log(hour, minutes, second);
  let time = "";
  let text = "";
  if (hour > 0) {
    text += "h";
    time += checkLength(hour) + type;
  }
  if (minutes > 0) {
    text += "m";
    time += checkLength(minutes) + type;
  } else if (status === "ms") {
    text += "m";
    time += "00" + type;
  }
  text += "s";
  time += checkLength(second);
  return {
    text,
    time,
  };
};

export const getTime = (totalSeconds) => {
  const second = checkLength(totalSeconds % 60);
  const minute = parseInt(totalSeconds / 60, 10);
  const minutes = checkLength(parseInt(minute % 60, 10));
  const hour = checkLength(parseInt(minute / 60, 10));
  return {
    hour,
    minutes,
    second,
  };
};

export const timeUI = (totalSeconds, status = "ms") => {
  const { hour, minutes, second } = getTime(totalSeconds);
  if (status === "ms" && parseInt(hour, 10) > 0) {
    status = "hms";
  }
  // console.log(hour, minutes, second);
  switch (status) {
    case "s":
      return second;
    case "ms":
      return minutes + ":" + second;
    case "hms":
    default:
      return hour + ":" + minutes + ":" + second;
  }
};

const checkLength = (data) =>
  parseInt(data, 10) < 10 ? "0" + parseInt(data, 10) : parseInt(data, 10);

export const rankIndex = (a, b) => {
  var textA = a["index"];
  var textB = b["index"];
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};

export const sortDate = (a, b) => {
  const dateA = typeof a.date === "number" ? a.date : Number(a.date);
  const dateB = typeof b.date === "number" ? b.date : Number(b.date);
  // console.log(typeof dateA,dateA);
  // console.log(typeof dateB,dateB);
  var textA = +new Date(dateA);
  var textB = +new Date(dateB);
  // console.log((textA < textB) ? -1 : (textA > textB) ? 1 : 0);
  return textA < textB ? 1 : textA > textB ? -1 : 0;
};

export const checkRole = (status, roles) => {
  if (roles !== undefined) {
    if (status === "gym") {
      return roles.includes("GYM_OWNER") || roles.includes("GYM_ADMIN");
    } else if (status === "coach") {
      return roles.includes("COACH");
    } else if (status === "all") {
      return (
        roles.includes("COACH") &&
        (roles.includes("GYM_OWNER") || roles.includes("GYM_ADMIN"))
      );
    }
  }
  return false;
};
// eslint-disable-next-line
export const CheckValue = (value) =>
  value !== null &&
  value !== undefined &&
  value !== "null" &&
  value !== "undefined" &&
  value !== "NaN" &&
  value !== NaN;

export const StaffSort = (data) =>
  data.filter((item, index, inputArray) => inputArray.indexOf(item) === index);

export const setStaff = (el, role) => ({
  first_name: el.first_name,
  last_name: el.last_name,
  profile_pic_original: el.profile_pic_original,
  profile_pic_thumb: el.profile_pic_thumb,
  // roles: checkRole('gym', role) ? 'owner' : 'coach',
  socket_id: [el.socket_id],
  user_id: el.user_id,
});

export const setCoach = (data) => ({
  first_name: data.first_name,
  last_name: data.last_name,
  created_by: data.created_by,
  user_id: data.created_by,
  profile_pic_thumb: data.profile_pic_thumb,
  waitingRoom_open_by: data.waiting_room_opened_by,
  host: data.waiting_room_opened_by === data.created_by,
  stream: false,
  owner_stream: false,
  isVideoStarted: false,
  owner_isVideoStarted: false,
  owner_web: false,
  owner_webTileId: null,
  owner_mobile: false,
  owner_mobileTileId: null,
  web: false,
  webTileId: null,
  mobile: false,
  mobileTileId: null,
});

export const setGym = (data) => ({
  name: data.gym_name,
  logo: data.logo_thumb,
  id: data.gym_id,
});

export const setWorkoutBuilder = (data, totalSeconds = 0) => {
  let prevMax = 0;
  console.log("data", data);
  data.workout_builder.sort(segmentSortOrder);
  data.workout_builder.forEach((el) => {
    let prevMaxTemp = prevMax;
    prevMax += el.segment_duration_in_seconds;
    el["combinedMax"] = prevMax;
    el["MIN"] = 0;
    el["MAX"] = el.segment_duration_in_seconds;
    el["STEP"] = 1;
    el["width"] =
      (el.segment_duration_in_seconds /
        data.total_activity_duration_in_seconds) *
        100 +
      "%";
    el.exercises.sort(exerciseSortOrder);
    el.exercises.forEach((ed) => {
      prevMaxTemp += ed.exercise_duration_in_seconds;
      ed["combinedExerciseMax"] = prevMaxTemp;
    });
    el["values"] = [0];
  });
};

const exerciseSortOrder = (a, b) => {
  var textA = Number(a["exercise_order"]);
  var textB = Number(b["exercise_order"]);
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};
export const segmentSortOrder = (a, b) => {
  var textA = Number(a["segment_order"]);
  var textB = Number(b["segment_order"]);
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};

export const setStaffInActivity = (data, staffsInActivity) => {
  data.staffsInActivity.forEach((el) => {
    let role = typeof el.roles === "string" ? [el.roles] : el.roles;
    if (checkRole("gym", role)) {
      return;
    }
    if (CheckValue(staffsInActivity[el.user_id])) {
      staffsInActivity[el.user_id].socket_id.push(el.socket_id);
      staffsInActivity[el.user_id].socket_id = StaffSort(
        staffsInActivity[el.user_id].socket_id
      );
    } else {
      staffsInActivity[el.user_id] = setStaff(el, role);
    }
  });
};

export const setUserInActivity = (data) => {
  const obj = {};
  if (data.usersInActivity && data.usersInActivity.length) {
    data.usersInActivity.forEach((element, index) => {
      obj[element.user_id] = setUserData(element, data.user_activity_data);
    });
  }
  return obj;
};

export const participantVisibility = (data) =>
  !CheckValue(data.participant_video_visibility_in_attempt) ||
  data.participant_video_visibility_in_attempt === "ALL" ||
  data.participant_video_visibility_in_attempt === "FRIENDS_ONLY";

export const setUserData = (element, user_activity_data) => {
  element["calories_burnt"] = element["calories_burnt"]
    ? Math.round(element["calories_burnt"])
    : 0;
  element["showStream"] = false;
  element["maxHeartRate"] = Math.round(208 - 0.7 * element["age"]);
  element["heartrate"] = Math.round(element["avg_heart_rate"]);
  // element['heartrate'] = 0;
  element["muted"] = true;
  if (
    element.video_stream &&
    (element.user_id === user_activity_data.user_id ||
      participantVisibility(element))
  ) {
    element["video_stream"] = true;
  } else {
    element["video_stream"] = false;
  }
  if (element.user_status_in_activity === "ENDED") {
    element["color"] = "#808080";
    element["opacity"] = "0.6";
  } else if (element.user_status_in_activity === "STARTED") {
    element["color"] = colorSelector(
      element["avg_heart_rate"]
        ? Math.round(
            (element["avg_heart_rate"] / element["maxHeartRate"]) * 100
          )
        : 0
    );
    element["opacity"] = "unset";
  }
  element["me"] = element.user_id === user_activity_data.user_id;
  return element;
};
export const setUserInOndemandActivity = (data) => {
  const obj = {};
  if (data.usersInActivity && data.usersInActivity.length) {
    data.usersInActivity.forEach((element, index) => {
      setOndemandUserData(element, index, data.new_user);
    });
    data.usersInActivity.sort(caloriesSort);
    data.usersInActivity
      .filter((el) => el.is_best_attempt)
      .forEach((el) => {
        if (participantVisibility(el)) {
        } else {
          el.ant_media_recording = null;
          el.video_stream = false;
        }
        if (el.me) {
          el.heartrate = 0;
          el.max_heart_rate_percent = 0;
        }
        if (!CheckValue(el.max_heart_rate_percent)) {
          el.max_heart_rate_percent = 0;
        }
        obj[el.user_id] = { ...el };
      });
    const meData = data.usersInActivity.filter((el) => el.me);
    meData
      .filter((el) => el.current_attempt)
      .forEach((el) => {
        if (participantVisibility(el)) {
          obj[el.user_id].ant_media_recording = el.ant_media_recording;
          obj[el.user_id].video_stream = el.video_stream;
        } else {
          obj[el.user_id].ant_media_recording = null;
          obj[el.user_id].video_stream = false;
        }
      });
    obj[data.new_user.user_id].total_attempts_yet = meData.length - 1;
    obj[data.new_user.user_id].user_activity_session_id =
      data.new_user.user_activity_session_id;
    obj[data.new_user.user_id].user_status_in_activity = staticVar.roomStarted;
  }
  return obj;
};

export const setOndemandUserData = (element, index, user_activity_data) => {
  element["calories_burnt"] = element["calories_burnt"]
    ? Math.round(element["calories_burnt"])
    : 0;
  element["maxHeartRate"] = Math.round(208 - 0.7 * element["age"]);
  element["rank"] = index + 1;
  element["heartrate"] = Math.round(element["avg_heart_rate"]);
  element["opacity"] = "unset";
  element["showStream"] = false;
  element["isVideoStarted"] = false;
  element["color"] = colorSelector(
    element["avg_heart_rate"]
      ? Math.round((element["avg_heart_rate"] / element["maxHeartRate"]) * 100)
      : 0
  );
  if (
    CheckValue(element["ant_media_recording"]) &&
    element["is_best_attempt"] &&
    participantVisibility(element)
  ) {
    element["video_stream"] = true;
  } else {
    element["video_stream"] = false;
  }
  if (element["is_best_attempt"]) {
    if (element.user_id === user_activity_data.user_id) {
      element["is_best_attempt"] = false;
    }
    element["current_attempt"] = true;
  } else {
    element["current_attempt"] = false;
  }

  if (
    element.user_activity_session_id ===
    user_activity_data.user_activity_session_id
  ) {
    element["is_best_attempt"] = true;
    element["video_stream"] =
      CheckValue(element["ant_media_recording"]) && element["is_best_attempt"];
  }
  element["me"] = element.user_id === user_activity_data.user_id;
  return element;
};
export const activityPolling = (ondemandData, socket) => {
  const data = {
    user_activity_session_id: ondemandData.user_activity_session_id,
    status: "PROGRESS",
  };
  socket.emit("ondemand_activity_sync", data, (res) => {
    //console.log('enter',res);
  });
};

export const currentWorkoutTime = (data, status) => {
  if (!CheckValue(data)) {
    return 0;
  }
  if (status) {
    return Math.round((new Date().getTime() - new Date(data).getTime()) / 1000);
  } else {
    return Math.round((new Date(data).getTime() - new Date().getTime()) / 1000);
  }
};

const deviceLabel = {
  audioin: "MacBook Pro Microphone (Built-in)",
  video: "FaceTime HD Camera (Built-in) (05ac:8514)",
  audioout: "MacBook Pro Speakers (Built-in)",
};
export const getDefaultAudioVideoDevice = (
  deviceList,
  deviceType = "audioout"
) => {
  if (!deviceList.length) {
    return null;
  }
  const video = deviceList.find((el) => el.label === deviceLabel[deviceType]);
  return video ? video.deviceId : deviceList[0].deviceId;
};

export const getMediaPermission = async (
  constraints,
  videoTagId,
  type = 0,
  status = true
) => {
  try {
    // The MediaDevices.getUserMedia() method prompts the user for permission to use a media input
    //  which produces a MediaStream with tracks containing the requested types of media.
    await navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function (mediaStreams) {
        if (type) {
          mediaStream.stream = mediaStreams;
        } else if (CheckValue(videoTagId)) {
          const ele = document.getElementById(videoTagId);
          if (CheckValue(ele)) {
            ele.srcObject = mediaStreams;
          }
        } else {
          mediaStreams.getAudioTracks().forEach(function (track) {
            track.stop();
          });
          mediaStreams.getVideoTracks().forEach(function (track) {
            //in case... :)
            track.stop();
          });
        }
      });
    return status ? getMediaDevices() : { status: true };
    // return { status: false };
  } catch (e) {
    return { status: false };
  }
};
export const stopMediaTrack = async (constraints) => {
  try {
    // The MediaDevices.getUserMedia() method prompts the user for permission to use a media input
    //  which produces a MediaStream with tracks containing the requested types of media.
    await navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function (mediaStream) {
        console.log(mediaStream.getTracks());
        var tracks = mediaStream.getTracks(); // if only one media track
        tracks.forEach(function (track) {
          track.stop();
        });
        // ...
        // track.stop();
      });
    return true;
  } catch (e) {
    return false;
  }
};

export const getMediaDevices = async (type) => {
  try {
    const gotDevices = await navigator.mediaDevices.enumerateDevices();
    const videoInputDevices = gotDevices.filter(
      (el) => el.kind === "videoinput" && el.deviceId !== "default"
    );
    const audioInputDevices = gotDevices.filter(
      (el) => el.kind === "audioinput" && el.deviceId !== "default"
    );
    const audioOutputDevices = gotDevices.filter(
      (el) => el.kind === "audiooutput" && el.deviceId !== "default"
    );
    return {
      status: true,
      videoInputDevices,
      audioInputDevices,
      audioOutputDevices,
      gotDevices,
    };
  } catch (e) {
    return { status: false };
  }
  // Each object in the array describes one of the available media input and output devices
  //  (only device-types for which permission has been granted are "available").
  //  The order is significant - the default capture devices will be listed first.
};

export const getAvailableUser = (user, status) => {
  var allUsersArr = [];
  if (status === "not_ended") {
    allUsersArr = Object.values(user).filter(
      (el) => el.user_status_in_activity !== staticVar.ended
    );
  } else {
    allUsersArr = Object.values(user).filter((el) =>
      status === "all" ? true : el.user_status_in_activity === status
    );
  }
  allUsersArr.sort(rankIndex);
  // const allUsersArr = [...allUsersArr1,...allUsersArr1,...allUsersArr1,...allUsersArr1,...allUsersArr1];
  const allUserLength = allUsersArr.length;
  return {
    allUsersArr,
    allUserLength,
  };
};

export const getOndemandAvailableUser = (user) => {
  const allUsersArr = Object.values(user).sort(rankSort);
  const allUserLength = allUsersArr.length;
  return {
    allUsersArr,
    allUserLength,
  };
};

export const participantSort = (a, b) => {
  var textA = a["stream"];
  var textB = b["stream"];
  return textA === textB ? 0 : textA ? -1 : 1;
};

export const caloriesSort = (a, b) => {
  var textA = a["calories_burnt"];
  var textB = b["calories_burnt"];
  return textA < textB ? 1 : textA > textB ? -1 : 0;
};
export const rankSort = (a, b) => {
  var textA = a.rank;
  var textB = b.rank;
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};

export const CheckAccess = (status) => {
  if (access[status]) {
    return access[status].value;
  }
  return true;
};

export const checkMemberVideoPermission = (visibility) =>
  !CheckValue(visibility) ||
  visibility === "ALL" ||
  visibility === "FRIENDS_ONLY";

/**OLD**/
/* export const headerView = () => {
  const location = useLocation()
  return location.pathname
} */
export const sortData = (a, b) => {
  var textA = (a["name"] || a["title"] || a["label"]).toUpperCase();
  var textB = (b["name"] || b["title"] || b["label"]).toUpperCase();
  return textA < textB ? -1 : textA > textB ? 1 : 0;
};
export const sortDate1 = (a, b) => {
  const dateA = typeof a.date === "number" ? a.date : Number(a.date);
  const dateB = typeof b.date === "number" ? b.date : Number(b.date);
  // console.log(typeof dateA,dateA);
  // console.log(typeof dateB,dateB);
  var textA = +new Date(dateA);
  var textB = +new Date(dateB);
  // console.log((textA < textB) ? -1 : (textA > textB) ? 1 : 0);
  return textA < textB ? 1 : textA > textB ? -1 : 0;
};
export const UniqueID = () => {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
};
export const getvalue = (option) =>
  typeof option === "string"
    ? option
    : Array.isArray(option)
    ? option.length
      ? getvalue(option[0])
      : ""
    : option[option.keyValue || "value"] || "";
export const getText = (id) => text[id] || "";
export const convertMinute = (minute) => {
  let minText = "Min";
  if (minute === undefined) {
    return `0 ${minText}`;
  }
  minute = Math.round(minute);
  if (minute < 60) {
    return `${minute} ${minText}${minute > 1 ? "s" : ""}`;
  } else {
    const minutes = parseInt(minute % 60, 10);
    const hour = parseInt(minute / 60, 10);
    if (minutes === 0) {
      return `${hour} Hour`;
    } else {
      return `${hour} Hour ${minutes} ${minText}${minutes > 1 ? "s" : ""}`;
    }
  }
};
export const convertTime2 = (totalSeconds, type = ":") => {
  const second = totalSeconds % 60;
  const minute = parseInt(totalSeconds / 60, 10);
  const minutes = parseInt(minute % 60, 10);
  const hour = parseInt(minute / 60, 10);

  let time = "";
  if (hour > 0) {
    time += checkLength(hour) + type;
  }
  if (minutes > 0) {
    time += checkLength(minutes) + type;
  }
  time += checkLength(second);
  return time;
};
export const convertTime3 = (totalSeconds, type = ":", status = "ms") => {
  const { hour, minutes, second } = getTime(totalSeconds);
  // console.log(hour, minutes, second);
  let time = "";
  let text = "";
  if (hour > 0) {
    text += "h";
    time += checkLength(hour) + type;
  }
  if (minutes > 0) {
    text += "m";
    time += checkLength(minutes) + type;
  } else if (status === "ms") {
    text += "m";
    time += "00" + type;
  }
  text += "s";
  time += checkLength(second);
  return {
    text,
    time,
  };
};
export const convertMinutes = (minute, status = "second") => {
  if (minute === undefined) {
    return 0;
  }
  if (status === "second") {
    minute = Math.round(minute * 60);
  }
  return minute;
};
export const convertMinutes1 = (minute) => {
  if (minute === undefined) {
    return 0;
  }
  return Math.round(minute);
};
export const getExtension = (filename) => {
  var parts = filename.split(".");
  return parts[parts.length - 1];
};
/* const convertSecond = (minute) => (minute * 60);
const convertMilisecond = (second) => (second * 1000); */
export const calculateTime = (second, type) => {
  const seconds = second % 60;
  const secondsP = Math.round(second);
  const secondP = pad(Math.round(seconds), 2);
  // console.log(second,seconds,Math.round(seconds),secondP);

  const minute = second / 60;
  const minutes = minute % 60;
  const minuteP = parseInt(minute, 10);

  const minutesP = pad(parseInt(minutes, 10), 2);

  const hour = minute / 60;
  const hourP = pad(parseInt(hour, 10), 2);

  switch (type) {
    case "h":
      return hourP;
    case "m":
      return minuteP;
    case "s":
      return secondsP;
    case "ms":
      return minuteP + ":" + secondP;
    case "hm":
      return hourP + ":" + minutesP;
    case "hms":
    default:
      return hourP + ":" + minutesP + ":" + secondP;
  }
};
const pad = (number, length) => {
  let str = "" + number;
  while (str.length < length) {
    str = "0" + str;
  }
  return str;
};
// New Code Implementation for New Casting Class
export const getActivityType = (el) => {
  const temp = activityType.filter(
    (res) => res.value === (typeof el === "string" ? el : el[0])
  );
  return temp.length ? temp[0] : [];
};
export const getActivityType1 = (el) => {
  const temp = activityType1.filter(
    (res) => res.value === (typeof el === "string" ? el : el[0])
  );
  return temp.length ? temp[0] : [];
};
export const getDuration = (el) => {
  const temp = timeDuration.filter((res) => res.value === el);
  return temp.length ? temp[0] : [];
};
const acceptedFileTypes =
  "image/x-png, image/png, image/jpg, image/jpeg, image/gif";
const acceptedFileTypesArray = acceptedFileTypes.split(",").map((item) => {
  return item.trim();
});
export const CheckImageType = (type) => acceptedFileTypesArray.includes(type);
export const formatBytes = (bytes, decimals = 2, condition = null) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1000;
  let dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  if (condition === null && dm !== 0 && i < 2) {
    dm = 0;
  }
  const value = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
  if (condition != null) {
    let temp = sizes.findIndex((el) => el === condition.sizeType);
    if (temp === i) {
      if (value <= condition.size) {
        return true;
      }
      return false;
    } else if (i < temp) {
      return true;
    } else {
      return false;
    }
  }
  return value + sizes[i];
};
export const getBuildDate = (epoch) => {
  const buildDate = moment(epoch).format("DD-MM-YYYY HH:MM");
  return buildDate;
};
export const checkBoxValue = (el) => {
  if (el.status === "time") {
    if (el.number === undefined || el.number === null) {
      return "0 hour";
    }
    const hour = Math.round(el.number / 3600);
    const number = hour <= 1 ? hour + " hour" : hour + " hours";
    return number;
  }
  return el.number ? Math.round(el.number) : 0;
};
export const progressEvent = (progressEvent) => {
  var percentCompleted = Math.round(
    (progressEvent.loaded * 100) / progressEvent.total
  );
  messageService.sendPercentMessage(
    percentCompleted < 100 ? percentCompleted : null
  );
};
export const setMaxDate = (startDate, max = 3) => {
  const date = new Date(startDate);
  return date.setMonth(date.getMonth() + max);
};
export const CheckWidth = (value, def = 74) => {
  if (value !== "") {
    const div = document.createElement("div");
    div.innerText = value;
    div.className = "valueCheck";
    document.body.appendChild(div);
    const width1 = div.clientWidth;
    div.remove();
    // document.body.appendChild(div);
    // return div.clientWidth+74
    // const temp1 = document.getElementById('valueCheck');
    // temp1.innerText = value;
    // const width = temp1.clientWidth;
    // temp1.innerText = '';
    return width1 + def;
  }
  return 0;
};
export const SetOption = (option) => ({
  name: option.name || undefined,
  label: option.label || option.title || undefined,
  value: getvalue(option),
  thumb: option.thumb || undefined,
  icon: option.icon || undefined,
  original: option.original || undefined,
  parent: option.parent || undefined,
  child: [],
  keyValue: "value",
});
export const GetGymId = () => {
  return userData.selectedGym.gym_id;
};
export const CheckActiveGym = (data) => {
  let gymsArray = [];
  if (data.roles && data.roles.length) {
    if (checkRole("gym", data.roles)) {
      if (data.gymsAdded.length) {
        // gymsArray = [...data.gymsAdded];
        gymsArray = getApprovedGyms(data.gymsAdded);
      }
    } else if (data.gyms.length) {
      gymsArray = getApprovedGyms(data.gyms);
    }
  }
  return gymsArray;
};
const isLetter = (str) => {
  return str.length === 1 && str.match(/[a-z]/i);
};
const isDigit = (str) => {
  return str.length === 1 && str.match(/[0-9]/i);
};
const isPassSpecial = (data) => {
  if (!data.length) {
    return false;
  } else {
    //    let letters = 0
    let numbers = 0;
    let specialChars = 0;
    for (let c of data.split("")) {
      if (isLetter(c)) {
        //    ++letters
      } else if (isDigit(c)) {
        ++numbers;
      } else {
        ++specialChars;
      }
    }
    return (
      numbers >= 2 || specialChars >= 2 || (numbers >= 1 && specialChars >= 1)
    );
  }
};
const isPassword = (data) => {
  return data.length && isPassSpecial(data);
};
export const CheckIfSpecialCharacter = (control) => {
  if (isPassword(control.value)) {
    return null;
  } else {
    return { matchingPassword: true };
  }
};
export const GetOffset = (el) => {
  let x = 0;
  let y = 0;
  while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
    x += el.offsetLeft - el.scrollLeft;
    y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: y, left: x };
};

export const getClassUserStatus = (
  isOndemand,
  activity_status,
  user_status_in_activity,
  start_datetime
) => {
  if (isOndemand) {
    return {
      btnEnabled: true,
      shouldStartClass: true,
      shouldBookClass: false,
      shouldCancelBooking: false,
      btnText: BTN_TEXTS.START_NOW,
    };
  }
  let btnEnabled,
    shouldStartClass,
    shouldBookClass,
    shouldCancelBooking = false;
  let btnText = "";

  switch (activity_status) {
    case ACTIVITY_STATUS.IN_WAITING_ROOM:
      btnEnabled = true;
      shouldStartClass = true;
      btnText = BTN_TEXTS.JOIN_WAITING_ROOM;
      break;
    case ACTIVITY_STATUS.STARTED:
      btnEnabled = true;
      shouldStartClass = true;
      btnText = BTN_TEXTS.JOIN_CLASS;
      break;
    case ACTIVITY_STATUS.IN_HANGOUT_ROOM:
      btnEnabled = true;
      shouldStartClass = true;
      btnText = BTN_TEXTS.JOIN_CLASS;
      break;
    default:
      if (differenceInSeconds(parseISO(start_datetime), new Date()) <= 0) {
        btnText = BTN_TEXTS.JOIN_WAITING_ROOM;
      } else if (
        user_status_in_activity === USER_STATUS_IN_ACTIVITY.BOOKED ||
        user_status_in_activity === USER_STATUS_IN_ACTIVITY.LEFT
      ) {
        btnEnabled = true;
        shouldCancelBooking = true;
        btnText = BTN_TEXTS.CANCEL;
      } else {
        btnEnabled = true;
        shouldBookClass = true;
        btnText = BTN_TEXTS.COUNT_ME_IN;
      }
  }

  /* if (
    user_status_in_activity === USER_STATUS_IN_ACTIVITY.BOOKED ||
    user_status_in_activity === USER_STATUS_IN_ACTIVITY.LEFT
  ) {
    switch (activity_status) {
      case ACTIVITY_STATUS.IN_WAITING_ROOM:
        btnEnabled = true
        shouldStartClass = true
        btnText = BTN_TEXTS.JOIN_WAITING_ROOM
        break
      case ACTIVITY_STATUS.STARTED:
        btnEnabled = true
        shouldStartClass = true
        btnText = BTN_TEXTS.JOIN_CLASS
        break
      case ACTIVITY_STATUS.IN_HANGOUT_ROOM:
        btnEnabled = true
        shouldStartClass = true
        btnText = BTN_TEXTS.JOIN_CLASS
        break
      default:
        btnEnabled = true
        shouldCancelBooking = true
        btnText = BTN_TEXTS.CANCEL
        break
    }
  } else {
    btnEnabled = true
    shouldBookClass = true
    btnText = BTN_TEXTS.COUNT_ME_IN
  } */
  return {
    btnEnabled,
    shouldStartClass,
    shouldBookClass,
    shouldCancelBooking,
    btnText,
  };
};

export const CheckValid = ({ get, ...props }) => {
  const length =
    get("password").hasError("required") ||
    get("password").hasError("minLength");
  const special =
    get("password").hasError("required") ||
    get("password").hasError("matchingPassword");
  return (
    <React.Fragment>
      <ValidUI {...props} cond={length} text="Be at least 10 characters long" />
      <ValidUI
        {...props}
        cond={special}
        text="Include 2 numbers or special characters"
      />
    </React.Fragment>
  );
};

const ValidUI = (props) => {
  const { textColor, color, cond, text } = props;
  let pStyle = {};
  if (CheckValue(textColor)) {
    pStyle["color"] = textColor;
  }
  let iconStyle = { marginRight: "10px" };
  if (CheckValue(color)) {
    if (!cond) {
      iconStyle["color"] = color;
    } else {
      iconStyle["color"] = "#D8D8D8";
    }
  }
  return (
    <p style={pStyle}>
      <FontAwesomeIcon
        style={iconStyle}
        className={`${cond ? "errors" : "valid"} marginR8`}
        icon={cond ? faCheckCircle : faCheckCircle}
      />
      {text}
    </p>
  );
};

export const convertFtToDecimal = (ft) => {
  const array = ft.split("'");
  console.log(array);
  const i = parseInt(array[0]);
  let decimal = 0;
  if (array[1]) {
    decimal = parseFloat(parseInt(array[1]) / 12);
  }
  console.log(i);
  console.log(decimal);
  console.log(i + decimal);
  return (i + decimal).toFixed(2);
};

export const convertDecimalToFt = (decimal) => {
  const array = decimal.toString().split(".");
  const ft = array[0];
  let inch = 0;
  if (array[1]) {
    inch = Math.round((parseFloat(decimal) - ft) * 12);
  }
  return ft + "'" + inch;
};

export const convertFtToCM = (ft) => {
  const decimalFt = convertFtToDecimal(ft);
  return (decimalFt * 30.48).toFixed(2);
};

export const convertCMToFt = (CM) => {
  const decimalFt = parseInt(CM) * 0.0328084;
  const array = decimalFt.toString().split(".");
  let ft = parseInt(array[0]);
  let inch = 0;
  if (array[1]) {
    inch = Math.round((decimalFt - ft) * 12);
  }
  if (inch === 12) {
    ft = ft + 1;
    inch = 0;
  }
  return ft + "'" + inch;
};

export const getPendingGyms = (gyms) =>
  gyms.filter((el) => el.linked_status === 0);
export const getApprovedGyms = (gyms) =>
  gyms.filter((el) => el.linked_status === 1);

export const moveToClass = (activity_status, history) => {
  const isWaitingRoom = activity_status === staticVar.waitingRoom;
  const isOngoingRoom = activity_status === staticVar.roomStarted;
  const isHangoutRoom = activity_status === staticVar.hangoutRoom;
  if (isWaitingRoom) {
    history.push(`/waitingRoom`);
  }
  if (isOngoingRoom) {
    history.push(`/ongoingRoom`);
  }
  if (isHangoutRoom) {
    history.push(`/hangoutRoom`);
  }
};
